/* eslint-disable jsx-a11y/alt-text */
import "../../assets/stylesheet/change-homepage.css";
import { CHECKIN, CHECKOUT, KEYPAGE } from "../../routes/Paths";
import { CONFIG_MASTER_ENUM, MODULE_MASTER_ENUM } from "../../constants/constant";
import React, { Suspense } from "react";
import { HOME } from "../../routes/Paths";

import {
  fetchModulesConfiguration,
} from "../../store/Checkin/moduleConfigurationSlice";
import {
  generateTokenApi,
  getAllowedDocuments,
} from "../../network/apiService";
import { getConfigurationCode, getModuleStatus, getParametersFromLocalStorage, getStepMaster, saveTokenInSessionStorage } from "../../helpers/commonHelper";
import {
  getSelectedLanguage,
  setSelectedLanguage,
} from "../../store/Checkin/languageSlice";
import {
  homePageHandler,
} from "../../helpers/commonHelper";
import { initReactI18next, useTranslation } from "react-i18next";
import {
  resetScanDocumentGuestCount,
  setDocumentInfo,
} from "../../store/Checkin/Scan/documentScanSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Backend from "i18next-http-backend";
import ErrorPopup from "../../components/LoaderAndNotification/ErrorPopup";
import LanguageDetector from "i18next-browser-languagedetector";
import LoaderPopup from "../../components/LoaderAndNotification/LoaderPopup";
import { STEP_MASTER_ENUM } from "../../constants/constant";
import i18n from "i18next";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import userConfirmation from "../../assets/images/userConfirmation.png";
import CloseIcon from "@mui/icons-material/Close";

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
  returnEmptyString: true,
  debug: false,
  fallbackLng: "en",

});

const HomePage = ({ type, currentStep }) => {

  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);
  const [loading, setLoading] = useState(false);
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const languages = getParametersFromLocalStorage("Languages");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [stepType, setStepType] = useState("");
  const [stepMaster, setStepMaster] = useState(null);
  const [stepMasterHome, setStepMasterHome] = useState(null);

  const [checkinModule, setcheckinModule] = useState(null);
  const [checkoutModule, setcheckoutModule] = useState(null);
  const [keyModule, setkeyModule] = useState(null);
  const [configs, setConfigs] = useState(null);
  const [changeHomepage, setChangeHomepage] = useState(null);
  const [languageRequired, setLanguageRequired] = useState(null);
  const [confirmationRequired, setConfirmationRequired] = useState(null);
  const [checkoutPaymentConfirmation, setPaymentCardConfirmationRequired] = useState(null);
  const [hideConsentImage, setHideConsentImage] = useState(null);
   const [paymentHideConsentImage, setPaymentHideConsentImage] = useState(null);

  const stepHomePage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.HOME_PAGE
  );
  
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false); 
  const [isKioskMaintenanceMode, setIsKioskMaintenanceMode] = useState(false); 
  const [isMaintanance, setIsMaintanance] = useState(false);
  const deviceDetails = getParametersFromLocalStorage("DeviceInfo");
  const maintenanceMode = getParametersFromLocalStorage("isMaintenanceMode");//Global setting for maintenance mode
  const kioskmaintenanceMode = getParametersFromLocalStorage("isKioskMaintenanceMode");//Kiosk setting for maintenance mode
  const [isActive, setIsActive] = useState(false);
  const [selectedLanguageCode, setSelectedLanguageCode] = useState(false);
  const [confirmationFlag, setConfirmation] = useState(0);
  const [clickFlag, setClick] = useState(0);
    const [checkoutclickFlag, setCheckoutClick] = useState(0);
  const [refresh, setRefresh] = useState(null);
  
  const closeModal = () => {
   setClick(false); // hide the modal
  };

  const settlementCardCloseModal = () => {
      setCheckoutClick(false);// hide the modal
  };
  
  const settings = getParametersFromLocalStorage("settings");

    const checkinpopuptimer = settings?.find(
    (setting) =>
      setting.parameterName === "Checkin_Homepage_popup_Timer"
  )?.parameterValue ?? 15000;
   const checkoutpopuptimer = settings?.find(
    (setting) =>
      setting.parameterName === "Checkout_Homepage_popup_Timer"
  )?.parameterValue ?? 15000;

  let isConfirmationApproved = false;
    
  let isCardConfirmationApproved = false;

  useEffect(async () => {
    var token = getParametersFromLocalStorage("token");

    if (token === null || token === "") {
      const uname = JSON.parse(localStorage.getItem("username"));
      const pwd = localStorage.getItem("password");
      if (
        uname === null ||
        uname === undefined ||
        uname === "" ||
        pwd === null ||
        pwd === undefined ||
        pwd === ""
      ) {
        navigate(`/`, { replace: true });
      } else {
        const response = await generateTokenApi({
          userName: JSON.parse(localStorage.getItem("username")),
          password: JSON.parse(localStorage.getItem("password")),
          kioskId: JSON.parse(localStorage.getItem("Kiosk"))
        });
        if (response.status === 200) {
          saveTokenInSessionStorage(response.data.token);
          setRefresh(1);
        }
      }
    }
  }, [])

  useEffect(() => {
    var token = getParametersFromLocalStorage("token");

    if ((stepMaster === null || stepMaster === undefined) && (token !== null)) {
      dispatch(
        fetchModulesConfiguration({
          IsStepEnabled: true,
          IsModuleEnabled: true,
          imageSpecified: true,
          Apptype: "kiosk",
          StepType: "checkin",
          token: token,
        })
      )
        .unwrap()
        .then((response) => {
          if (response !== null) {
            setModulesAndConfigs(response);
          }
          setStepMaster(response);

        });
      //setStepType("");
    }

  }, [refresh]);

  useEffect(() => {
    if (currentStep) {
      getCurrentStep();
    }
  }, [currentStep]);

  const getCurrentStep = () => {
    const documentScan = getStepMaster(stepMaster, currentStep);
    return documentScan;
  };
  useEffect(() => {

  }, [stepMaster, currentStep]);

  useEffect(() => {
    const maintananceMode = deviceDetails
      ? deviceDetails.find((ele) => ele?.settingsName === "MaintananceMode")
      : null;

    if (maintananceMode?.settingsValue === "True") {
      setIsMaintanance(true);
    } else {
      setIsMaintanance(false);
    }
  }, [deviceDetails]);

  useEffect(() => {
    const lng = localStorage.getItem("defaultLanguage") ?? 'en';
    i18n.changeLanguage(lng);
    dispatch(setSelectedLanguage(lng));
    setSelectedLanguageCode(lng);
  }, []);

  const setModulesAndConfigs = (stepMaster) => {
    const stepMasterHome1 = getStepMaster(stepMaster, currentStep);
    setStepMasterHome(stepMasterHome1);

    const modules = stepMasterHome1?.modules;

    const _checkinModule = getModuleStatus(modules, MODULE_MASTER_ENUM.CHECKIN);
    const _checkoutModule = getModuleStatus(modules, MODULE_MASTER_ENUM.CHECKOUT);
    const _keyModule = getModuleStatus(modules, MODULE_MASTER_ENUM.KEY);

    const stepHomePage = getStepMaster(
      stepMaster,
      STEP_MASTER_ENUM.HOME_PAGE
    );
    const config = stepHomePage?.configs;

    setConfigs(config);


    //const configs = stepHomePage?.configs;
    const changeHomepage1 = getConfigurationCode(//ss
      config,
      CONFIG_MASTER_ENUM.CHANGE_HOMEPAGE
    );
    const languageRequired1 = getConfigurationCode(
      config,
      CONFIG_MASTER_ENUM.LANGUAGE
    );
    const confirmationRequired1 = getConfigurationCode(
      config,
      CONFIG_MASTER_ENUM.DOCUMENT_CONFIRMATION_REQUIRED
    );

     const checkoutPaymentCardConfirmation = getConfigurationCode(
      config,
      CONFIG_MASTER_ENUM.CHECKOUT_PAYMENT_CARD_CONFIRMATION_REQUIRED
    );
    
    const configValue = getConfigurationCode(config, CONFIG_MASTER_ENUM.HIDE_CONSENT_IMAGE);
    const hideConsentImage1 = configValue === undefined ? true : configValue;


    const paymentConcentConfigValue = getConfigurationCode(config, CONFIG_MASTER_ENUM.PAYMENT_HIDE_CONSENT_IMAGE);
    const PaymentHideConsentImage1 = paymentConcentConfigValue === undefined ? true : paymentConcentConfigValue;


    setChangeHomepage(changeHomepage1);
    setLanguageRequired(languageRequired1);
    setConfirmationRequired(confirmationRequired1);
    setHideConsentImage(hideConsentImage1);

    setPaymentHideConsentImage(PaymentHideConsentImage1);
    setPaymentCardConfirmationRequired(checkoutPaymentCardConfirmation);


    setcheckinModule(_checkinModule);
    setcheckoutModule(_checkoutModule);
    setkeyModule(_keyModule);
  }


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    dispatch(setSelectedLanguage(lng));
    setIsActive(true);
    setSelectedLanguageCode(lng);
  };

  useEffect(() => {
    homePageHandler(dispatch, null);
  }, []);
  useEffect(() => {
    let timer;
    if (confirmationRequired && clickFlag) {
      timer = setTimeout(() => {
        setClick(false); 
        isConfirmationApproved = false; 
      }, checkinpopuptimer); 
    }

    // Cleanup function to clear timeout when modal closes manually
    return () => clearTimeout(timer);
  }, [confirmationRequired, clickFlag]);


  useEffect(() => {
    let paymenttimer;
    if (checkoutPaymentConfirmation && checkoutclickFlag) {
      paymenttimer = setTimeout(() => {
        setCheckoutClick(false); 
        isCardConfirmationApproved = false; 
      }, checkoutpopuptimer); 
    }

    // Cleanup function to clear timeout when modal closes manually
    return () => clearTimeout(paymenttimer);
  }, [checkoutPaymentConfirmation, checkoutclickFlag]);



  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };


  const generateToken = async (navigateUrl) => {

    try {

      if (navigateUrl == CHECKOUT && checkoutPaymentConfirmation && !isCardConfirmationApproved) {
        setCheckoutClick(true);
         return;
      }

      
      if (navigateUrl == CHECKIN && confirmationRequired && !isConfirmationApproved) {
        setClick(true);
        return;
      }
    
      else {
        setLoading(true);
        dispatch(resetScanDocumentGuestCount());

        const response = await generateTokenApi({
          userName: JSON.parse(localStorage.getItem("username")),
          password: JSON.parse(localStorage.getItem("password")),
          kioskId: JSON.parse(localStorage.getItem("Kiosk"))
        });
        if (response.status === 200) {
          const data = response.data || {};


          const docTypes = await getAllowedDocuments(
            {
              appType: "kiosk",
            },
            data?.token
          );

          if (docTypes?.data?.result) {
            dispatch(setDocumentInfo(docTypes?.data?.data));
          }

          if (navigateUrl !== "") {
            if (navigateUrl == CHECKIN) {

              dispatch(
                fetchModulesConfiguration({
                  IsStepEnabled: true,
                  IsModuleEnabled: true,
                  imageSpecified: true,
                  Apptype: "kiosk",
                  StepType: "checkin",
                  token: data?.token,
                })
              );
              setStepType("checkin");
            } else if (navigateUrl == CHECKOUT) {
              
              // if (checkoutPaymentConfirmation && !isCardConfirmationApproved) {
              //     setCheckoutClick(true);
              //   }
                
              dispatch(
                fetchModulesConfiguration({
                  IsStepEnabled: true,
                  IsModuleEnabled: true,
                  imageSpecified: true,
                  Apptype: "kiosk",
                  StepType: "checkout",
                  token: data?.token,
                })
              );
              setStepType("checkout");
            } else if (navigateUrl == KEYPAGE) {
              dispatch(
                fetchModulesConfiguration({
                  IsStepEnabled: true,
                  IsModuleEnabled: true,
                  imageSpecified: true,
                  Apptype: "kiosk",
                  StepType: "key",
                  token: data?.token,
                })
              );
              setStepType("key");
            }
            setLoading(false);
            navigate(navigateUrl, { replace: true });
          } else {
            dispatch(
              fetchModulesConfiguration({
                IsStepEnabled: true,
                IsModuleEnabled: true,
                imageSpecified: true,
                Apptype: "kiosk",
                StepType: "",
                token: data?.token,
              })
            );
            setStepType("");
            setLoading(false);

          }

        }

      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: error.message,
      }));
      return;
    }

    return;
  };

  return (

    (stepMaster) ? <>
      <div>

        <section className="section-bg" style={{ display: !isMaintanance ? 'block' : 'none' }}>
          {
            changeHomepage === true ? (

              <>
                <div className="container-fluid">
                  <div className="">
                    <div className="row">
                      <div className="col-sm-6 pl-0 pr-0">
                        <div className="h-100 relative">
                          <div className="vh-100">
                            {/* <div className="content-center"> */}
                            <div className="content-center mt-50">
                              <div >
                                <div className="logo-img text-center ">
                                  <img id="logoImg" />
                                </div>
                              </div>

                              <div className="mt-50">
                                <div>
                     
                                  <p className="text-center  yotel-welcome-subtitle">
                                    {t("Please select an option")} {t("to begin")}
                                  </p>
                                </div>

                                <div className="text-center mt-30">
                                  <div className="mt-30">
                                    {checkinModule !== null ? (
                                      <>
                                        <button id="btn-yotelhomepage-checkin"
                                          onClick={() => {
                                            generateToken(CHECKIN);
                                          }}
                                          className="btn btn-lg button-blue yotel-check-in-btn"
                                        >
                                          {t("CHECK - IN")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>

                                  <div >
                                    {checkoutModule ? (
                                      <>
                                        <button id="btn-yotelhomepage-checkout"
                                          onClick={() => {
                                            generateToken(CHECKOUT);
                                          }}
                                          className="btn btn-lg button-blue yotel-check-in-btn"
                                        >
                                          {t("CHECK - OUT")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>

                                  <div className="mt-15">
                                    {keyModule ? (
                                      <>

                                        <button id="btn-yotelhomepage-key"
                                          onClick={() => {
                                            generateToken("/key-page");
                                          }}
                                          className="btn btn-lg button-blue yotel-check-in-btn"
                                        >
                                          {t("KEY")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>
                                </div>

                                {
                                  languageRequired === true &&
                                  <>
                                    <div className="flex text-center ">
                                      <div className="mt-90" >
                                        <p className="text-center  yotel-welcome-subtitle">
                                          {t("Choose the language")}:
                                        </p>
                                      </div>
                                      {/* <br /> */}

                                      <div>
                                        <select className="yotel-custom-select" onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
                                          {languages.map(language => (
                                            <option key={language.languageMasterID} value={language.languageCode}>
                                              {language.languageName}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div>
                                      </div>
                                    </div>
                                  </>
                                }



                              </div>
                            </div>
                          </div>
                          <LoaderPopup loading={loading} />
                          <ErrorPopup
                            closeErrorModal={closeErrorModal}
                            erroModalData={erroModalData}
                          />
                          <Suspense fallback={<div>loading</div>}></Suspense>
                        </div>
                      </div>

                      <div className="col-sm-6 pr-0"></div>
                    </div>
                  </div>
                </div>
              </>
            ) : (



              // changeHomepage === null &&
              <>
                <div className="container-fluid">
                  <div className="">
                    <div className="row">
                      <div className="col-sm-6 pl-0 pr-0">
                        <div className="h-100 relative">
                          <div className="vh-100">
                            <div className="content-center">
                              <div>
                                <div className="logo-img text-center">
                                  <img id="logoImg" />
                                </div>
                              </div>

                              <div className="mt-50">
                                <div>
                                  <h2 className="welcome-title home-welcome-title">
                                    {t("Welcome")}
                                    <p>
                                      {t("Property")
                                        .split("\n")
                                        .map((line, index) => (
                                          <React.Fragment key={index}>
                                            {line}
                                          </React.Fragment>
                                        ))}
                                    </p>
                                  </h2>
                                  <p className="text-center font-14 welcome-subtitle">
                                    {t("Please select an option")} {t("to begin")}
                                  </p>
                                </div>

                                <div className="text-center mt-30">
                                  <div>
                                    {checkinModule ? (
                                      <>
                                        <button id="btn-homepage-checkin"
                                          onClick={() => {
                                            generateToken(CHECKIN);
                                          }}
                                          className="btn btn-lg button-blue check-in-btn button-custom"
                                        >
                                          {t("CHECK - IN")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>

                                  <div className="mt-30">
                                    {checkoutModule ? (
                                      <>
                                        <button id="btn-homepage-checkout"
                                          onClick={() => {
                                            generateToken(CHECKOUT);
                                          }}
                                          className="btn btn-lg button-blue check-in-btn button-custom"
                                        >
                                          {t("CHECK - OUT")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>

                                  <div className="mt-90">
                                    {keyModule ? (
                                      <>
                                        <p className="text-center font-14 key-text">
                                          {t("Did you lose your key?")}
                                        </p>
                                        <button id="btn-homepage-key"
                                          onClick={() => {
                                            generateToken("/key-page");
                                          }}
                                          className="btn btn-lg button-blue-outline check-in-btn button-key-custom"
                                        >
                                          {t("KEY")}
                                        </button>
                                      </>
                                    ) : null}
                                  </div>
                                </div>

                                {
                                  languageRequired === true &&
                                  <>
                                    <div
                                      className="flex text-center "
                                    >
                                      <div className="mt-90" >
                                        <p className="text-center font-14 welcome-subtitle">
                                          {t("Choose the language:")}
                                        </p>
                                      </div>
                                      <br />

                                      <div>
                                        <select className="custom-select"

                                          onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
                                          {languages.map(language => (
                                            <option key={language.languageMasterID} value={language.languageCode}>
                                              {language.languageName}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                      <div>
                                      </div>
                                    </div>
                                  </>
                                }


                              </div>
                            </div>
                          </div>
                          {
                            confirmationRequired === true && clickFlag === true && (
                              // <DocumentConfirmationModal confirmationPopupFlag={confirmationRequired} />
                              <>

                                <div>
                                  <Modal open={confirmationRequired}   style={{ zIndex: "1" } }>
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "32%",
                                        backgroundColor: "#f5f5f5",
                                        border: "2px #000",
                                        boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
                                        padding: "50px",
                                        borderRadius: "20px",
                                      }}
                                    >
                                      <button id="btn-flipdocmodal-close" className="close-icon" onClick={closeModal}>
                                                  <CloseIcon
                                                    style={{ float: "right", margin: "5px", color: "white" }}
                                                    // onClick={true}
                                                  />
                                                </button>
                                      <div style={{ textAlign: "center" }}>

                                        <div >
                                          <i class="fa fa-id-card-o" aria-hidden="true"></i>
                                          {!hideConsentImage && (
                                            <img src={userConfirmation} alt="Logo" style={{ width: "80px", height: "auto" }} />
                                          )}

                                        </div>

                                        {/* Message */}
                                        <div style={{ textAlign: "justify" }}>
                                          <p>{t("Check-in consent")}</p>

                                        </div>

                                        {/* Buttons */}
                                        <div style={{ marginTop: "30px" }}>

                                          <button
                                            id="btn-homepage-confirm"
                                            className="btn confirm-modal-yes-btn"

                                            style={{
                                              display: "block",
                                              width: "70%", // Optional: Full-width buttons
                                            }}
                                            onClick={() => {

                                              setClick(false);
                                              isConfirmationApproved = true;
                                              generateToken(CHECKIN);

                                            }}>
                                            {t("CONFIRM AND CHECK-IN")}
                                          </button>
                                          <br />
                                          {/* <button id="btn-homepage-goback"
                                            className="btn modal-no-btn"
                                            style={{

                                              display: "block",
                                              width: "70%", // Optional: Full-width buttons
                                              marginRight: "15%"
                                            }}
                                            data-bs-dismiss="modal"
                                            onClick={() => {
                                             
                                               //window.location.reload();
                                            }
                                            }

                                          >
                                            {t("GO BACK")}
                                          </button> */}

                                        </div>
                                      </div>
                                    </Box>
                                  </Modal>
                                </div>

                              </>
                            )}

                             {
                            checkoutPaymentConfirmation === true && checkoutclickFlag === true && (
                              // <DocumentConfirmationModal confirmationPopupFlag={confirmationRequired} />
                              <>

                                <div>
                                  <Modal open={checkoutPaymentConfirmation}   style={{ zIndex: "1" } }>
                                    <Box
                                      sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: "32%",
                                        backgroundColor: "#f5f5f5",
                                        border: "2px #000",
                                        boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
                                        padding: "50px",
                                        borderRadius: "20px",
                                      }}
                                    >
                                      <button id="btn-flipdocmodal-close" className="close-icon" onClick={settlementCardCloseModal}>
                                                  <CloseIcon
                                                    style={{ float: "right", margin: "5px", color: "white" }}
                                                    // onClick={true}
                                                  />
                                                </button>
                                      <div style={{ textAlign: "center" }}>

                                        <div className="checkout-conf-img">
                                          {!paymentHideConsentImage && (
                                            <img  id="paymentConfirmationImg" alt="Logo" style={{ width: "80px", height: "auto" }} />
                                           )} 

                                        </div>

                                        {/* Message */}
                                        <div style={{ textAlign: "justify" }}>
                                          <p>{t("Checkout Card Consent")}</p>

                                        </div>

                                        {/* Buttons */}
                                        <div style={{ marginTop: "30px" }}>

                                          <button
                                            id="btn-homepage-confirm"
                                            className="btn confirm-modal-yes-btn"

                                            style={{
                                              display: "block",
                                              width: "70%", // Optional: Full-width buttons
                                            }}
                                            onClick={() => {

                                              setcheckoutModule(false);
                                              isCardConfirmationApproved = true;
                                              generateToken(CHECKOUT);

                                            }}>
                                            {t("CONFIRM AND CHECK-OUT")}
                                          </button>
                                          <br />
                                          {/* <button id="btn-homepage-goback"
                                            className="btn modal-no-btn"
                                            style={{

                                              display: "block",
                                              width: "70%", // Optional: Full-width buttons
                                              marginRight: "15%"
                                            }}
                                            data-bs-dismiss="modal"
                                            onClick={() => {
                                             
                                               //window.location.reload();
                                            }
                                            }

                                          >
                                            {t("GO BACK")}
                                          </button> */}

                                        </div>
                                      </div>
                                    </Box>
                                  </Modal>
                                </div>

                              </>
                            )}

                          
                          <LoaderPopup loading={loading} />
                          <ErrorPopup
                            closeErrorModal={closeErrorModal}
                            erroModalData={erroModalData}
                          />
                          <Suspense fallback={<div>loading</div>}></Suspense>
                        </div>
                      </div>

                      <div className="col-sm-6 pr-0"></div>
                    </div>
                  </div>
                </div>
              </>

            )}
        </section>
    
      </div>
    </> :
      <>
        <LoaderPopup loading={true} />
      </>
  );
};

export default HomePage;
